import { useState, useEffect } from "react";
import { ScreencastLogo } from "bingo/screencast/components/ScreencastLogo";
import QRCode from "react-qr-code";
import {
  DEFAULT_WHITE_COLOR,
  // DEFAULT_RED_COLOR
} from "_graphic_design";
import { BingoGame } from "bingo/types/bingo-game.model";
import { config } from "../../../config";
import { useMantineTheme } from "@mantine/core";
interface RunningBingoGameProps {
  backgroundSize: string;
  bingoGame: BingoGame;
}

export function RunningBingoGame(props: RunningBingoGameProps) {
  const { backgroundSize, bingoGame } = props;
  const theme = useMantineTheme();
  // console.log(
  //   "url",
  //   `${config.webAppRoot}/event?bingoGameId=${bingoGame.id}&L1=${bingoGame?.bingoTemplateSnapshot?.access?.organization}`,
  // );

  // Use regular state initialization instead of shorthand
  const [shownNumbers, setShownNumbers] = useState<number[]>(
    bingoGame.drawNumbersList || [],
  );
  const [gameState, setGameState] = useState<
    "NOT_STARTED" | "IN_PROGRESS" | "CLOSED"
  >(bingoGame.status || "NOT_STARTED");

  // Use useEffect to update the state when bingoGame changes
  useEffect(() => {
    if (bingoGame.drawNumbersList) {
      setShownNumbers(bingoGame.drawNumbersList);
    }
  }, [bingoGame.drawNumbersList]);

  useEffect(() => {
    if (bingoGame.status) {
      setGameState(bingoGame.status);
    }
  }, [bingoGame.status]);

  // console.log("bingoGame", bingoGame.status);

  // Page content components
  const WelcomePage = () => (
    <div
      className="flex h-full w-full justify-between"
      style={{ fontFamily: theme.fontFamily }}
    >
      <ScreencastLogo bingoGame={bingoGame} />

      <div
        className="flex flex-col text-center justify-center mx-auto items-center "
        style={{
          color:
            bingoGame.bingoTemplateSnapshot?.publicScreenSettings.messagesColor,
          fontSize:
            bingoGame.bingoTemplateSnapshot?.publicScreenSettings.messagesSize,
        }}
      >
        {/* Bienvenue au Bingo! <br /> Le jeu va bientôt commencer */}
        {bingoGame.bingoTemplateSnapshot?.publicScreenMessages.welcome}
      </div>
      <div className="flex flex-col justify-center mr-4">
        {bingoGame.gridQRCodeAccess?.trim() && (
          <div style={{ backgroundColor: DEFAULT_WHITE_COLOR, padding: 8 }}>
            <QRCode
              size={120}
              fgColor="#000000"
              bgColor={DEFAULT_WHITE_COLOR}
              value={`${config.webAppRoot}/event?bingoGameId=${bingoGame.id}&L1=${bingoGame?.bingoTemplateSnapshot?.access?.organization}`}
            />
          </div>
        )}
      </div>
    </div>
  );

  const GameplayPage = () => (
    <div className="flex h-full w-full justify-between items-center">
      <ScreencastLogo bingoGame={bingoGame} />
      <div className="flex justify-center items-center ml-[300px] mr-[200px] ">
        <div className="w-[220px] h-[220px] text-[180px] text-white rounded-full border-4 border-white p-4 bg-transparent text-center flex items-center justify-center">
          {shownNumbers.length > 0 ? shownNumbers[shownNumbers.length - 1] : ""}
        </div>
      </div>
      <div className="flex flex-row gap-0 my-auto mr-4 flex-wrap justify-start">
        {[...shownNumbers]
          .slice(0, -1)
          //.slice(-10)
          .reverse()
          .map((num, index) => (
            <div
              key={index}
              className=" text-white text-8xl text-center border-none"
            >
              {index === 0 ? num : `-${num}`}
            </div>
          ))}
      </div>
    </div>
  );
  const WinnerPage = () => (
    <div
      className="flex items-center h-full w-full"
      style={{ fontFamily: theme.fontFamily }}
    >
      <ScreencastLogo bingoGame={bingoGame} />
      <div
        className="flex flex-col h-full w-full justify-center items-center text-center"
        style={{
          color:
            bingoGame.bingoTemplateSnapshot?.publicScreenSettings.messagesColor,
          fontSize:
            bingoGame.bingoTemplateSnapshot?.publicScreenSettings.messagesSize,
        }}
      >
        {bingoGame.winnerInfo ? (
          <span>
            Bingo ! Félicitations {bingoGame.winnerInfo.firstName}{" "}
            {bingoGame.winnerInfo.lastName} ! <br />
            Vous avez remporté la partie !
          </span>
        ) : (
          <span>
            {bingoGame.bingoTemplateSnapshot?.publicScreenMessages.endOfGame}
          </span>
        )}
      </div>
    </div>
  );

  // Handle background size differently
  const backgroundSizeParts = backgroundSize
    ? backgroundSize.split(" ")
    : ["100%", "100%"];
  const widthStyle = backgroundSizeParts[0] || "100%";
  const heightStyle = backgroundSizeParts[1] || "100%";

  // Render the appropriate component based on game state
  let pageToShow;
  if (gameState === "NOT_STARTED") {
    pageToShow = <WelcomePage />;
  } else if (gameState === "IN_PROGRESS") {
    pageToShow = <GameplayPage />;
  } else {
    pageToShow = <WinnerPage />;
  }

  return (
    <div style={{ width: widthStyle, height: heightStyle }}>{pageToShow}</div>
  );
}
